// extracted by mini-css-extract-plugin
export default {"pageContainer":"Privacy_pageContainer__v7-4B","updated":"Privacy_updated__0c5vR"};